export default "__VITE_ASSET__48bfe1a3__"